import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { themeTabOptions, themeTabs } from './constants'

const useTabs = () => {
  const { t } = useTranslation()
  const [selectedTab, setSelectedTab] = useState(themeTabs.appearance)

  const tabs = themeTabOptions.map(tab => ({
    ...tab,
    label: t(tab.label),
  }))

  return { tabs, selectedTab, setSelectedTab }
}

export default useTabs
